module.exports = __webpack_public_path__ + "img/1864.22fb10e1.gif";